import React, { useContext } from "react";
import { ControllerActions, ControllerType } from "components/util/controller";
import { HostControllerContext } from "components/presentation/main/Main.lib.communication";
import View from "./AppMenu.view";

// The side menu a project's app asks for with /helpers/Menu. The app owns the entries —
// they are routes of its own router — and the host owns the one thing the app cannot reach
// from inside itself: which solution this is, and the way to another one.
//
// Changing solution is NOT reimplemented here. The header opens the start panel, the same
// component the topbar's button opens, so there is one solution list in the product and
// not a second one that drifts from it.
//
// Whether that panel is open is passed in rather than held here: the project's app can
// open it too, through /helpers/Menu's `openMenu`, so the flag lives above this component
// where both sides can reach it.

const AppMenu = ({
  flow,
  activePath,
  isCollapsed = false,
  isStartShown = false,
  items = [],
  showFlows = true,
  title,
  closeStart,
  onClickToggleStart,
}) => {

  const host = useContext(HostControllerContext);

  // Routing goes back out the way a process's NAVIGATE does: the app owns its router, so
  // the host hands it the path instead of resolving it.
  const onClickItem = (path) => {
    if (!path) return;
    host?.sendControllerAction?.({
      type: ControllerType.ACTION,
      name: ControllerActions.Navigate,
      path,
    });
  }

  // An entry is current when the route is it, or is nested under it — so /reports stays
  // marked while the app is on /reports/12. The root is matched whole, or it would be
  // marked on every screen.
  const isItemActive = (path) => {
    if (!activePath || !path) return false;
    if (path == "/") return activePath == "/";
    return activePath == path || activePath.startsWith(`${path}/`);
  }

  // The test id is derived from the route so the checklist can address an entry without
  // knowing its label, which is translated: "/reports/open" reads as "reports-open".
  const menuItems = (items || [])
    .filter(item => item?.path)
    .map(item => ({
      ...item,
      isActive: isItemActive(item.path),
      testId: item.path.replace(/^\/+/, "").replace(/\//g, "-") || "root",
    }));

  return <View
    activeFlow={flow}
    isCollapsed={isCollapsed}
    isStartShown={showFlows && isStartShown}
    items={menuItems}
    showFlows={showFlows}
    title={title || flow.name}
    closeStart={closeStart}
    onClickItem={onClickItem}
    onClickToggleStart={onClickToggleStart}
  />;

}

export default AppMenu;
